<template>
  <header class="navbar navbar-expand-lg navbar-dark custom-navbar">
    <div class="container">
      <a href="#" class="navbar-brand">
        <img :src="Logo" alt="Logo" class="img-fluid">
      </a>

      <nav class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" :class="{ actives: activeLink === 'overview' }" href="#overviewSection"
              @click="setActiveLink('overview')">Overview</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ actives: activeLink === 'recent' }" href="#recentSection"
              @click="setActiveLink('recent')">Recent
              Ancestry</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ actives: activeLink === 'parent' }" href="#parentSection"
              @click="setActiveLink('parent')">Parental</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ actives: activeLink === 'history' }" href="#historySection"
              @click="setActiveLink('history')">Historical</a>
          </li>
        </ul>
      </nav>

      <div class="right-bar">
        <a  href="#explore" class="btn btn-outline-primary btn-sm">Unlock Your Story</a>
      </div>
    </div>
  </header>
</template>
<script>
import Logo from '@/assets/images/logos/living-dna-updated-logo.svg'
export default {
  data() {
    return {
      Logo,
      activeLink: 'overview',
    };
  },
  methods: {
    setActiveLink(link) {
      this.activeLink = link;
    }
  }
};
</script>